import { render, staticRenderFns } from "./player-item.vue?vue&type=template&id=29619e8f&scoped=true&"
import script from "./player-item.vue?vue&type=script&lang=js&"
export * from "./player-item.vue?vue&type=script&lang=js&"
import style0 from "./player-item.vue?vue&type=style&index=0&id=29619e8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29619e8f",
  null
  
)

export default component.exports